<template>
  <v-container
    id="user-profile"
    fluid
    tag="section"
    style="background-color: white"
  >
    <div class="text-sm-right mb-4 d-flex justify-space-between">
      <filter-form
          :types="listTypeSchoolLevel"
          :filter-form="filterForm"/>

      <div>
        <v-select
            class="filter-store-btn"
            v-model="filterForm.store"
            :items="stores"
            item-text="name"
            item-value="value"
            dense
            outlined
            hide-details
            @change="getHoldContactSettingsFilter()"
        />
      </div>
    </div>
    <div>
      <hold-contact-setting-table
          v-if="holdContactSettings.length"
          :filter-form="filterForm"
          :holdContactSettings="holdContactSettings"
          :storeTypeList="storeTypeList"
          :contactStatusList="contactStatusList"
      />
      <v-row class="mt-0">
        <v-col
            cols="12"
            sm="6"
        />
        <v-col
            cols="12"
            sm="6"
        >
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
  import FilterForm from './components/FilterForm.vue'
  import HoldContactSettingTable from "./components/HoldContactSettingTable";
  import RepositoryFactory from '../../repositories/RepositoryFactory'
  const HoldContactSettingRepository = RepositoryFactory.get('hold_contact_setting');
  const ContactStatusRepository = RepositoryFactory.get('contact_status');
  const SchoolLevelRepository = RepositoryFactory.get('school_level');
  import { contactStatusDefaultColor, KHO_C, KHO_T } from "../../helpers/constants";

  export default {
    components: { HoldContactSettingTable, FilterForm },
    data () {
      return {
        filterForm: {
          store: 'T'
        },
        holdContactSettings: [],
        stores: [
          { value: 'T', name: 'Kho T' },
          { value: 'C', name: 'Kho C' }
        ],
        storeTypeList: [],
        contactStatusList: [],
        listTypeSchoolLevel: [],
        loading: false
      }
    },
    watch: {

    },
    async created () {
      await Promise.all([
        this.getContactStatusList(),
        this.getListTypeSchoolLevel(),
        this.getShowColumn()
      ])
      this.getHoldContactSettings()
      Bus.$on('reload-hold-contact-setting', () => {
        this.getHoldContactSettingsFilter()
      })
      Bus.$on('hold-contact-setting-filter', () => {
        this.getHoldContactSettings()
      })
    },
    beforeDestroy () {
      Bus.$off('reload-hold-contact-setting')
      Bus.$off('hold-contact-setting-filter')
    },
    methods: {
      async getListTypeSchoolLevel() {
        if(this.$store.state.listSchoolLevelDrawer) {
          this.listTypeSchoolLevel  = _.cloneDeep(this.$store.state.listSchoolLevelDrawer)
          return
        }
        const res = await SchoolLevelRepository.listTypeSchoolLevel()
        if (res.success) {
          this.listTypeSchoolLevel = _.get(res, 'data', [])
        } else {
          this.listTypeSchoolLevel = []
        }
      },
      async getHoldContactSettings() {
        this.loading = true
        this.appLoadingData(true)
        const response = await HoldContactSettingRepository.list({...this.filterForm});
        if (_.get(response, 'success', false)) {
          let rawDataHoldContact = response?.data;
          const holdContactSettings = [];
          this.listTypeSchoolLevel.forEach(type => {
            if (this.filterForm.typeId && this.filterForm.typeId != type.id) {
              return
            }
            type.schoolLevel.forEach(schoolLevel => {
              if (this.filterForm.schoolLevelId && this.filterForm.schoolLevelId != schoolLevel.id) {
                return
              }
              const store = this.filterForm.store;
              let keepDate = this.getKeepDateForItem({type, schoolLevel, store, holdContactList: rawDataHoldContact})
              let notKeepContact = rawDataHoldContact.find(item => item.typeId == type.id && item.schoolLevelId == schoolLevel.id && item.store == store)
              holdContactSettings.push({
                name: `${type.name} - ${schoolLevel.name}`,
                typeId: type.id,
                schoolLevelId: schoolLevel.id,
                keepDate,
                store,
                notKeepContact: notKeepContact ? notKeepContact.notKeepContact.split(',').map(e => +e) : []
              })
            })
          })
          this.loading = false
          this.appLoadingData(false)
          this.holdContactSettings = holdContactSettings
        }
      },
      getKeepDateForItem ({type, schoolLevel, store, holdContactList}) {
        let keepDates = {}
        this.storeTypeList.forEach(storeType => {
          const keepDateStoreType = holdContactList.find(item => item.typeId == type.id && item.schoolLevelId == schoolLevel.id && item.store == store && item.storeType == storeType)
          keepDates[storeType] = {
            id: keepDateStoreType?.id || null,
            storeType,
            date: keepDateStoreType ? keepDateStoreType.keepDate : 0,
            isEdit: false
          }
        })
        return keepDates
      },
      getShowColumn () {
        if (this.filterForm?.store == 'T') {
          this.storeTypeList = KHO_T
        } else if (this.filterForm?.store == 'C') {
          this.storeTypeList = KHO_C
        }
      },
      async getContactStatusList() {
        this.appLoadingData(true)
        const response = await ContactStatusRepository.list({
          store: this.filterForm.store
        });
        this.appLoadingData(false)
        if (response.success) {
          const contactStatusList = [];
          _.get(response, 'data', []).forEach(contactStatus => {
            contactStatusList.push({
              header: contactStatus?.type,
              typeId: contactStatus['data'] && contactStatus['data'].length ? contactStatus['data'][0]?.typeId : null,
              schoolLevelId: contactStatus['data'] && contactStatus['data'].length ? contactStatus['data'][0]?.schoolLevelId : null
            })
            _.get(contactStatus, 'data', []).forEach(data => {
              contactStatusList.push({
                type: contactStatus.type,
                id: _.get(data, 'id', 0),
                name: `${contactStatus?.type.slice(-2)} - ${_.get(data, 'name', '')}`,
                color:
                    _.get(data, 'color', contactStatusDefaultColor) ||
                    contactStatusDefaultColor,
                typeId: data?.typeId,
                schoolLevelId: data.schoolLevelId
              });
            });
          });
          this.contactStatusList = contactStatusList;
        } else {
          this.contactStatusList = [];
        }
      },
      async getHoldContactSettingsFilter () {
        this.holdContactSettings = []
        await Promise.all([
          this.getContactStatusList(),
          this.getShowColumn()
        ])
        this.getHoldContactSettings()
      }
    },
  }
</script>

<style scoped>
/deep/ .filter-store-btn.v-text-field {
  border: 1px solid black;
  border-radius: 8px;
  width: 120px;
}

/deep/ .filter-store-btn.v-select .v-select__selections {
  font-size: 16px;
  font-weight: 400;
  padding: 0px !important;
}

/deep/ .filter-store-btn.v-select .v-input__control .v-input__slot {
  min-height: fit-content !important;
}

/deep/ .filter-store-btn.v-select.v-text-field--outlined fieldset {
  border: unset;
}

/deep/ .filter-store-btn.v-select .v-input__append-inner {
  margin-top: 5px !important;
}

/deep/ .filter-store-btn.v-select .v-input__append-inner .v-icon.primary--text {
  color: black !important;
}
</style>
